(ns app.front.view.group.admin.integration.target-editor
  (:require [app.front.ui :as ui]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [potpuri.core :as p]))


(def integration-keys [:integration/category
                       :integration/work-type
                       :integration/work-target])


(defn integration-targets [{:keys [tr *group-config parent-config]}]
  (let [parent-int     (:group.config/integration parent-config)
        integration    (:group.config/integration @*group-config)
        backend-system (<sub [::gas/backend-system-name])]
    (when (<sub [::gas/has-feature? :group.feature/backend-system-integration])
      (cc/form-group
        {:legend-text (tr [:integration-config/backend-integration-codes]
                          [backend-system])}

        (when (seq (dissoc parent-int :db/id))
          [:div.flex.flex-wrap.items-center
           [:div.mr-2 (str (tr [:integration-config/inherited-from-parent]) ":")]
           (for-frag [k integration-keys
                      :let [v (get parent-int k)]
                      :when v]
             [:div.bg-ui-blue-10.rounded.p-1.mr-2
              [:span.uppercase.text-xs.mr-2 (tr [k])]
              [:span.font-mono v]])])

        [:div.flex.flex-wrap.-mx-2
         (for-frag [k integration-keys]
           [:div.w-64.m-2
            [ui/text-input {:label-text  (tr [k])
                            :input-class "font-mono"
                            :value       (k integration "")
                            :placeholder (get parent-int k "")
                            :on-change   #(let [v (futil/tval %)]
                                            (if (str/blank? v)
                                              (swap! *group-config
                                                     p/dissoc-in
                                                     [:group.config/integration k])
                                              (swap! *group-config
                                                     assoc-in
                                                     [:group.config/integration k]
                                                     (futil/tval %))))}]])]))))
